<script setup>
import { trans } from '@elements/translation';

const props = defineProps({
  status: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div class="status-label" :class="`status-label--${status}`">
    {{ trans(`gestion.invoice.status.invoice.${status}`) }}
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.status-label {
  margin-left: 8px;
}
</style>
